import React from 'react';
import logo from '../images/logo1.svg';

const PageNotFound = () => {
    return (
        <div className='container'>
            <div className='row'> 
                <img src={logo} className='col-md-8 col-sm-12'/>
                <p className='display-4 col-md-4 col-sm-12'>404 Page Not Found</p>
            </div>
        </div>
    );
};

export default PageNotFound;